import { Theme } from '@infotech-soe/erp-ui-kit';
import { createUseStyles } from 'react-jss';

interface StylesProps {
  rows: number;
  columns: number;
}

export const useItemStyles = createUseStyles({
  themeCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px',
    border: '2px solid transparent',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'border-color 0.2s ease',
    outline: 'none',
  },
  bigColorPatch: {
    width: 48,
    height: 48,
    borderRadius: 4,
    border: '1px solid rgba(0, 0, 0, 0.3)',
    flexShrink: 0,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    overflow: 'hidden',
  },
});

export const useStyles = createUseStyles(({ sizes }: Theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: ({ columns }: StylesProps) =>
      `repeat(${columns}, 1fr)`,
    gap: '2px',
    maxHeight: ({ rows }: StylesProps) => {
      const cardHeight = 76; // 48px (bigColorPatch) + 24px (padding 12*2) + 4px (border 2*2)
      const gap = 2;
      const containerPadding = 4; // 2px * 2
      return rows * cardHeight + (rows - 1) * gap + containerPadding;
    },
    overflowY: 'auto',
    border: sizes.inputContainer.border,
    borderRadius: sizes.inputContainer.borderRadius,
    padding: '2px',
  },
}));
